<template>
  <div>
    <el-button
      v-if="isMobile"
      :type="isMobile ? 'info' : 'text'"
      :plain="isMobile"
      :size="isMobile ? 'small' : 'small'"
      :style="isMobile ? 'text-transform: uppercase' : 'font-size: 13px'"
      :class="isMobile ? 'd_add d_back' : ''"
      @click="handleRequestSend"
    >
      Отправить реестр на почту
    </el-button>

    <el-dropdown-item v-else @click.native="handleRequestSend">
      Отправить реестр на почту
    </el-dropdown-item>

    <!--    <el-dialog-->
    <!--      title="Отправка реестра на почту"-->
    <!--      :visible.sync="dialog_button"-->
    <!--      :width="isMobile ? '90%' : '50%'"-->
    <!--      append-to-body-->
    <!--    >-->
    <!--      <loader-wrapper :loading="loading">-->
    <!--        <el-form ref="form" :model="formData" class="send-register-select">-->
    <!--          <el-form-item-->
    <!--            prop="receivers"-->
    <!--            :rules="{-->
    <!--              required: true,-->
    <!--              message: 'Добавьте получателя',-->
    <!--              trigger: 'blur',-->
    <!--            }"-->
    <!--          >-->
    <!--            <el-input-->
    <!--              v-model="formData.receivers"-->
    <!--              placeholder="Добавьте получателя"-->
    <!--            />-->
    <!--          </el-form-item>-->
    <!--        </el-form>-->
    <!--        <el-row type="flex" justify="space-between">-->
    <!--          <el-button @click="onClear">Очистить</el-button>-->
    <!--          <el-button type="primary" @click="sendToEmail">Отправить</el-button>-->
    <!--        </el-row>-->
    <!--      </loader-wrapper>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
// import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Doc = RepositoryFactory.get('document')
const registryBidRepository = RepositoryFactory.get('registryBidRepository')

export default {
  name: 'SendEmailButton',
  // components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    inn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog_button: false,
      formData: {
        receivers: [],
      },
      options: [],
      loading: false,
    }
  },
  methods: {
    onClear() {
      this.formData.receivers = ''
    },
    handleRequestSend() {
      registryBidRepository
        .checkRegistryFields({ day_id: this.id, by_mail: 1 })
        .then(() => {
          Doc.getUpdatedRegistry(this.id, 1)
            .then(res => {
              const { status } = res

              if (status === 200 || status === 204) {
                this.$message.success('Успешно отправлено')
                this.rewrightStorage()
                this.dialog_button = false
              }
              this.loading = false
            })
            .catch(({ response }) => {
              if (response) {
                const { status, data } = response

                if (status === 422) {
                  this.$message.error(data)
                }
              } else {
                this.$message.error('Ошибка отправки')
              }
              this.loading = false
            })
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    // onOpen() {
    //   this.dialog_button = true
    //   this.formData.receivers = JSON.parse(
    //     localStorage.getItem('port-register-emails'),
    //   )
    //     ? JSON.parse(localStorage.getItem('port-register-emails'))[0]
    //     : ''
    // },
    rewrightStorage() {
      const emails = [...new Set(this.options.concat(this.formData.receivers))]

      localStorage.setItem('port-register-emails', JSON.stringify(emails))
    },
    // sendToEmail() {
    //   this.$refs['form'].validate(valid => {
    //     if (valid) {
    //       this.loading = true
    //       Doc.sendToEmail(this.formData.receivers, {
    //         day_id: this.id,
    //         bid_creator_inn: this.inn,
    //       })
    //         .then(res => {
    //           const { status } = res
    //
    //           if (status === 200 || status === 204) {
    //             this.$message.success('Успешно отправлено')
    //             this.rewrightStorage()
    //             this.dialog_button = false
    //           }
    //           this.loading = false
    //         })
    //         .catch(({ response }) => {
    //           if (response) {
    //             const { status, data } = response
    //
    //             if (status === 422) {
    //               this.$message.error(data)
    //             }
    //           } else {
    //             this.$message.error('Ошибка отправки')
    //           }
    //           this.loading = false
    //         })
    //     }
    //   })
    // },
  },
}
</script>

<style lang="sass">
.send-register-select
  margin: 20px auto 30px
</style>
